const INACTIVITY_TIMEOUT = parseInt(process.env.VUE_APP_INACTIVITY_TIMEOUT) || 900; // saniye
const WARNING_DURATION = parseInt(process.env.VUE_APP_WARNING_DURATION) || 60000; // swal timer (ms)

let intervalId = null;

export const state = {
  remaining: INACTIVITY_TIMEOUT,
  isRunning: false,
  showWarning: false,
  warningDuration: WARNING_DURATION,
};

export const getters = {
  isRunning: (state) => state.isRunning,
  remaining: (state) => state.remaining,
  showWarning: (state) => state.showWarning,
  warningDuration: (state) => state.warningDuration,
};

export const mutations = {
  TICK(state) {
    state.remaining -= 1;
  },
  RESET(state) {
    state.remaining = INACTIVITY_TIMEOUT;
    state.showWarning = false;
  },
  SET_RUNNING(state, value) {
    state.isRunning = value;
  },
  SET_WARNING(state, value) {
    state.showWarning = value;
  },
};

export const actions = {
  start({ commit, state, dispatch }) {
    if (state.isRunning) return;
    commit('SET_RUNNING', true);
    commit('RESET');

    intervalId = setInterval(() => {
      dispatch('tick');
    }, 1000);
  },

  stop({ commit }) {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
    commit('SET_RUNNING', false);
    commit('RESET');
  },

  reset({ commit }) {
    commit('RESET');
  },

  tick({ commit, state }) {
    if (state.remaining > 0) {
      commit('TICK');
    } else if (!state.showWarning) {
      commit('SET_WARNING', true);
    }
  },

  dismissWarning({ commit }) {
    commit('RESET');
  },
};
